import Vue from 'vue';


export default {
  state: {
  },
  actions: {
    // 获取要上传的图片地址
    getUploadAddress(ctx, params){
      return Vue.http.post('/client/other/get-upload-address', params)
    },
    //根据图片链接获取完整链接
    otherGetFile(ctx, params){
      return Vue.http.post('/client/other/other-getFile', params)
    },
  },
  mutations: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/other.js